var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@material-ui/core';
import { FlexRow, HoverScale } from '@xyo-network/sdk-xyo-react-js';
import iosDownload from './img/download-on-the-app-store-apple.svg';
import androidDownload from './img/get-it-on-google-play.svg';
const DownloadButtonBox = (props) => {
    const { android = true, ios = true, androidLink = 'https://coin.onelink.me/ePJg/5d978f09', iosLink = 'https://coin.onelink.me/ePJg/76594177' } = props, rootProps = __rest(props, ["android", "ios", "androidLink", "iosLink"]);
    return (_jsxs(FlexRow, Object.assign({ flexWrap: "wrap", justifyContent: "center" }, rootProps, { children: [ios ? (_jsx(FlexRow, Object.assign({ flexShrink: 1, margin: 0.5 }, { children: _jsx(HoverScale, { children: _jsx(Link, Object.assign({ href: iosLink }, { children: _jsx("img", { alt: "Available on the AppStore", height: "45", src: iosDownload }, void 0) }), void 0) }, void 0) }), void 0)) : null,
            android ? (_jsx(FlexRow, Object.assign({ flexShrink: 1, margin: 0.5 }, { children: _jsx(HoverScale, { children: _jsx(Link, Object.assign({ href: androidLink }, { children: _jsx("img", { alt: "Get it on Google Play", height: "45", src: androidDownload }, void 0) }), void 0) }, void 0) }), void 0)) : null] }), void 0));
};
export default DownloadButtonBox;
